/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formpurpose_Startdate_Label_3to6months2Inputs */

const ja_contact_formpurpose_startdate_label_3to6months2 = /** @type {(inputs: Contact_Formpurpose_Startdate_Label_3to6months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3ヶ月から6ヶ月以内`)
};

const en_contact_formpurpose_startdate_label_3to6months2 = /** @type {(inputs: Contact_Formpurpose_Startdate_Label_3to6months2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Between 3 and 6 months`)
};

/**
* | output |
* | --- |
* | "Between 3 and 6 months" |
*
* @param {Contact_Formpurpose_Startdate_Label_3to6months2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formpurpose_startdate_label_3to6months2 = /** @type {((inputs?: Contact_Formpurpose_Startdate_Label_3to6months2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formpurpose_Startdate_Label_3to6months2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formpurpose_startdate_label_3to6months2(inputs)
	return en_contact_formpurpose_startdate_label_3to6months2(inputs)
});
export { contact_formpurpose_startdate_label_3to6months2 as "contact_formPurpose_startDate_label_3to6months" }